itsoftApp.createModule(
  "formsValidation",
  ["pageLoad", "addEvent"],
  function () {
    var module = this;
    var RECAPTCHA_KEY = "6LePSPUaAAAAAFtdK3SV8HcMvvERIXD06wJsrZfz";
    var libraries = {
      captcha: {
        name: "captcha",
        queue: [],
        started: false,
        loaded: false,
        script: `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_KEY}`,
      },
    };

    const { addEvent } = itsoftApp.modules.addEvent.callback;

    var startSetup = function (validationElement) {
      var init = function () {
        var form = validationElement.querySelector(".js-form-validate");
        var allInputs = form.querySelectorAll(".form__input");
        var allFormFlags = form.querySelectorAll(".form__flag");
        var isCaptcha = form.hasAttribute("data-captcha");
        var inputEventFlag = false;
        var submitFlag = false;
        var captchaAction = "question_form";
        var popupResultSuccess = document.querySelector(
          "#popup-result-success"
        );
        var popupResultError = document.querySelector("#popup-result-error");

        var onFormSubmit = function (evt) {
          if (!submitFlag) {
            submitFlag = true;
            const formData = new FormData(form);

            if (!isCaptcha) {
              sendRequest(formData, onSuccessLoad, onErrorLoad);
            } else {
              if (form.getAttribute("data-captcha") !== "") {
                captchaAction = form.getAttribute("data-captcha");
              }

              grecaptcha
                .execute(RECAPTCHA_KEY, { action: captchaAction })
                .then((token) => {
                  return new Promise((resolve) => {
                    formData.append("captcha-token", token);
                    formData.append("captcha-action", captchaAction);
                    resolve();
                  });
                })
                .then(() => sendRequest(formData, onSuccessLoad, onErrorLoad))
                .catch((err) =>
                  console.log(
                    "Возможно ошибка на проверке этапа reCaptcha",
                    err
                  )
                );
            }
          }
        };

        var validateForm = function () {
          var checkInput = function (input) {
            input.setCustomValidity("");
            input.classList.add("js-error");
          };

          var onFieldInput = function (evt) {
            if (evt.target.checkValidity()) {
              if (evt.target.classList.contains("js-error")) {
                evt.target.classList.remove("js-error");
              }
            }
          };

          var onInputInvalid = function (evt) {
            checkInput(evt.target);

            if (!inputEventFlag) {
              inputEventFlag = true;

              Array.prototype.forEach.call(allInputs, function (input) {
                input.addEventListener("input", onFieldInput);
              });

              Array.prototype.forEach.call(allFormFlags, function (flag) {
                flag.addEventListener("change", onFieldInput);
              });
            }
          };

          Array.prototype.forEach.call(allInputs, function (input) {
            input.addEventListener("invalid", onInputInvalid);
          });

          Array.prototype.forEach.call(allFormFlags, function (flag) {
            flag.addEventListener("invalid", onInputInvalid);
          });
        };

        var onErrorLoad = function (data) {
          if (popupResultError) {
            popupResultError.dispatchEvent(openEvent);
          }
          submitFlag = false;
        };

        var resetForm = function () {
          var inputsFilled = form.querySelectorAll(".form__input--filled");

          form.reset();

          Array.prototype.forEach.call(inputsFilled, function (input) {
            input.classList.remove("form__input--filled");
          });
        };

        var onSuccessLoad = function (data) {
          var openedPopups = document.querySelectorAll(".popup.is-opened");
          resetForm();

          if (openedPopups) {
            Array.prototype.forEach.call(openedPopups, function (popup) {
              popup.dispatchEvent(closeEvent);
            });
          }

          if (popupResultSuccess) {
            popupResultSuccess.dispatchEvent(openEvent);
          }
          submitFlag = false;
        };

        var sendRequest = function (data, onSuccess, onError) {
          var xhr = new XMLHttpRequest();
          var URL = form.action;

          xhr.addEventListener("load", function () {
            if (xhr.status === 200 && onSuccess) {
              onSuccess(xhr.response);
            } else {
              onError(xhr.response);
            }
          });

          xhr.open("POST", URL);
          xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
          xhr.send(data);
        };

        validateForm();

        form.onsubmit = function (evt) {
          evt.preventDefault();
          onFormSubmit();
        };
      };

      addEvent(init, "captcha", libraries);
    };

    module.callback = startSetup;
  }
);
